import { GzSandboxNetworkSensorWebComponent } from './component/GzSandboxNetworkSensorWebComponent';

export { GzSandboxNetworkSensorWebComponent };
